import { useVirtualizer } from '@tanstack/react-virtual';
import React, { ReactNode, useRef } from 'react';

import { $VirtualListContainer, $VirtualListInner } from './VirtualList.styles';

export interface VirtualListProps<T> {
  items: T[];
  estimateSize: (index: number) => number;
  renderItem: (item: T, index: number, style: React.CSSProperties) => ReactNode;
  containerHeight?: string;
  overscan?: number;
}

export function VirtualList<T>({
  items,
  estimateSize,
  renderItem,
  containerHeight,
  overscan = 4,
}: VirtualListProps<T>) {
  const parentRef = useRef<HTMLDivElement>(null);

  const rowVirtualizer = useVirtualizer({
    count: items.length,
    getScrollElement: () => parentRef.current,
    estimateSize,
    overscan,
  });

  const virtualItems = rowVirtualizer.getVirtualItems();

  return (
    <$VirtualListContainer ref={parentRef} $maxHeight={containerHeight}>
      <$VirtualListInner $height={rowVirtualizer.getTotalSize()}>
        {virtualItems.map((virtualItem) => {
          const item = items[virtualItem.index];
          const style: React.CSSProperties = {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: `${virtualItem.size}px`,
            transform: `translateY(${virtualItem.start}px)`,
          };

          return renderItem(item, virtualItem.index, style);
        })}
      </$VirtualListInner>
    </$VirtualListContainer>
  );
}
